import { useNavigate } from "react-router-dom";
import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCampagneAttiveScreeningAction, setCampagnaAction } from "../../modules/persistentStore/actions";
import { INFOCOLONRETTO, SCREENINGCOLONRETTO } from "../../global/urlMapping";
import { ReactComponent as LogoColonRetto } from "../../resources/icone/ColonRetto.svg";
import { ReactComponent as LogoMammografico } from "../../resources/icone/Tumorealseno.svg";
import { setMessaggioAction } from "../../modules/messaggio/actions";
import { ERRORE_CAMPAGNA_INATTIVA } from "../../global/messaggioLabels";
import images from "../../resources/export";
import { campagneAttiveScreeningSelector } from "../../modules/persistentStore/selectors";
import { ASL_3, ASL_5 } from "../../global/multiAsl";

export const Campagne = () => {
    const campagneAttiveScreening = useSelector(campagneAttiveScreeningSelector)

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onClickPartecipa = (typeCode) => {
        if (typeCode === "CL") {
            dispatch(setCampagnaAction("CL"))
            navigate(SCREENINGCOLONRETTO)
        }
        else {
            dispatch(setMessaggioAction({ status: ERRORE_CAMPAGNA_INATTIVA }))
        }
    }

    const onClickInfo = (typeCode) => {
        if (typeCode === "CL") {
            navigate(INFOCOLONRETTO)
        }
        else {
            dispatch(setMessaggioAction({ status: ERRORE_CAMPAGNA_INATTIVA }))
        }
    }
    const IconaScreening = ({ type }) => {
        if (type === 'CL') {
            return <LogoColonRetto style={{ width: "50px", marginRight: "15px" }} />
        }
        else if (type === 'MX') {
            return <LogoMammografico style={{ width: "30px", marginRight: "15px" }} />
        }
        else
            return null
    }


    useEffect(() => {
        dispatch(getCampagneAttiveScreeningAction())
        window.scrollTo(0, 0)
    }, [dispatch])

    return (
        <>

            <Box className="bg"
                sx={{
                    flexGrow: 1,
                    overflow: 'hidden',
                    with: "100%",
                    heigth: "auto",
                }}>

                <Box sx={{ x: 'auto' }}>
                    <Grid container wrap="nowrap" spacing={2}>
                        <Grid item xs zeroMinWidth>

                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                <Typography
                                    component='h1'
                                    sx={{
                                        color: "#005397",
                                        margin: "auto",
                                        textAlign: "center",
                                        fontSize: { xs: "25px", md: "40px" },
                                        fontWeight: 700,
                                    }}
                                >
                                    Consulta le campagne di screening disponibili
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {/*TODO FILTRO CL DA TOGLIERE!!!!!!!! */}
                {
                    campagneAttiveScreening && campagneAttiveScreening?.value && Array.isArray(campagneAttiveScreening?.value) ?
                        campagneAttiveScreening?.value?.filter((element) => element?.typeCode === "CL")?.map((element, index) =>
                        (
                            <Box key={index} sx={{ my: 4, mx: 'auto' }}>
                                <Grid container wrap="nowrap" spacing={2}>
                                    <Grid item xs zeroMinWidth>
                                        <Box
                                            sx={{
                                                width: "100%",
                                                margin: "auto",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Paper elevation={6}
                                                sx={{
                                                    borderRadius: '20px',
                                                    overflow: 'hidden',
                                                    textDecoration: "none !important",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                }}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        paddingY: "3vh",
                                                        paddingX: '6vw',
                                                        backgroundColor: '#ffffff',
                                                        display: "flex",
                                                        flexDirection: "column"
                                                    }}
                                                >
                                                    <Typography
                                                        component="h2"
                                                        sx={{
                                                            color: "#005397",
                                                            fontSize: { xs: "20px", md: "25px" },
                                                            fontWeight: 700,
                                                            textAlign: "center",
                                                            mb: "30px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center"
                                                        }}
                                                    >
                                                        <IconaScreening type={element?.typeCode} />
                                                        {element?.name}
                                                    </Typography>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: 'center',
                                                            gap: '3vw'
                                                        }}
                                                    >
                                                        <Button
                                                            sx={{
                                                                borderWidth: '2px',
                                                                borderColor: '#005397',
                                                                "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px', color: "white" },
                                                                color: '#005397',
                                                                borderRadius: '20px',
                                                                fontWeight: 700,
                                                            }}
                                                            variant="outlined"
                                                            onClick={() => { onClickInfo(element?.typeCode) }}
                                                        >
                                                            INFO
                                                        </Button>
                                                        <Button
                                                            id="accediCampagna"
                                                            sx={{
                                                                borderWidth: '2px',
                                                                borderColor: '#005397',
                                                                bgcolor: "#005397",
                                                                "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px' },
                                                                color: 'white',
                                                                borderRadius: '20px',
                                                                fontWeight: 700,
                                                            }}
                                                            variant="outlined"
                                                            onClick={() => { onClickPartecipa(element?.typeCode) }}
                                                        >
                                                            Accedi alla campagna
                                                        </Button>
                                                    </Box>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        height: '30px',
                                                        backgroundColor: '#005397',
                                                        width: "100%",
                                                        display: "flex"
                                                    }}

                                                >
                                                    <Box sx={{ width: "100%", display: 'flex', gap: '1vw', justifyContent: "center", alignItems: "center" }}>
                                                        <Typography
                                                            component="h2"
                                                            sx={{
                                                                color: "white",
                                                                fontSize: "15px",
                                                                fontWeight: 500,
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            Disponibile per:
                                                        </Typography>
                                                        {
                                                            element.asl.includes(ASL_3.codice) &&
                                                            <img src={images.loghi.logoAsl3Bianco} style={{ width: "50px" }} alt="asl3" />
                                                        }
                                                        {
                                                            element.asl.includes(ASL_5.codice) &&
                                                            <img src={images.loghi.logoAsl5Bianco} style={{ width: "50px" }} alt="asl5" />
                                                        }

                                                    </Box>
                                                </Box>
                                            </Paper>
                                        </Box>
                                    </Grid>
                                </Grid >
                            </Box >
                        ))
                        :
                        <Box >
                            <Box
                                sx={{
                                    minHeight: "300px",
                                    width: "100%",
                                    display: "flex",
                                    margin: "auto",
                                    flexDirection: "column",
                                    backgroundColor: "transparent ",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#005397",
                                        fontSize: { xs: "30px", md: "45px" },
                                        fontWeight: 700,
                                        margin: "auto",
                                        textAlign: "center",
                                        width: "60%",
                                        wordWrap: "inherit" /* {xs: 'none', md: 'break-word'} */,
                                    }}
                                >
                                    Non sono presenti campagne attive
                                </Typography>
                            </Box>
                        </Box>

                }
            </Box >
        </>



    );
};
